import React, { Component } from "react";
import "./userProfile.scss";
import Button from "@material-ui/core/Button";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import axios from "axios";
import translator from "../../../utils/translator";

class UserProfile extends Component {
	state = {
		name: "",
		address_1: "",
		city: "",
		postal: "",
		phone: "",
		website: "",
		hours: "",
		province: "",
		listOfWarehouses: [],
		listOfEmails: [],
		primaryWarehouse: 0, // Index of warehouse list
		primaryEmail: 0, // Index of email list
		response: {}
	};

	items = {
		email: "listOfEmails",
		warehouse: "listOfWarehouses"
	};

	async componentDidMount() {
		try {
			const instance = axios.create({
				headers: { Authorization: "Bearer " + localStorage.getItem("token") }
			});
			let getUserProfileUrl = this.props.APIUrl + "/consultant/consultant-profile";

			let APIResponse = await instance.get(getUserProfileUrl);

			let consultantProfile = APIResponse.data.consultantProfile;

			let newState = {
				name: consultantProfile.name,
				address_1: consultantProfile.address_1,
				city: consultantProfile.city,
				postal: consultantProfile.postal,
				phone: consultantProfile.phone,
				website: consultantProfile.website,
				hours: consultantProfile.hours,
				province: consultantProfile.province
			};

			let warehouses = APIResponse.data.consultantWarehouses.map((warehouse, index) => {
				if (warehouse.primary) newState.primaryWarehouse = index;
				return { ...warehouse, deleted: 0, added: 0 };
			});
			newState.listOfWarehouses = warehouses;

			let emails = APIResponse.data.consultantEmails.map((email, index) => {
				if (email.primary) newState.primaryEmail = index;
				return { ...email, deleted: 0, added: 0 };
			});
			newState.listOfEmails = emails;

			this.setState(newState);
		} catch (error) {
			console.log("here is the error message ", error.message);
		}
	}

	updateConsultant = async () => {
		const instance = axios.create({
			headers: { Authorization: "Bearer " + localStorage.getItem("token") }
		});
		// Updated basic information
		let updateConsultantAPIUrl = this.props.APIUrl + "/consultant/consultant-profile";

		let state = this.state;
		let data = {
			profile: {
				name: state.name,
				address_1: state.address_1,
				city: state.city,
				postal: state.postal,
				phone: state.phone,
				website: state.website,
				hours: state.hours,
				province: state.province
			},
			language: this.props.selected_language,
			warehouses: state.listOfWarehouses.map((w, i) =>
				i === state.primaryWarehouse ? { ...w, primary: 1 } : { ...w, primary: 0 }
			),
			emails: state.listOfEmails.map((e, i) =>
				i === state.primaryEmail ? { ...e, primary: 1 } : { ...e, primary: 0 }
			)
		};
		this.setState({ response: { loadingbar: "Loading..." } });
		let response = await instance.patch(updateConsultantAPIUrl, data);
		this.setState({ response: response.data });
	};

	addItem = key => {
		this.setState(state => ({
			...state,
			[this.items[key]]: [
				...state[this.items[key]],
				{ id: 0, [key]: "", primary: false, deleted: 0, added: 1 }
			]
		}));
	};

	editItem = (key, index, itemKey, value) => {
		let newItems = this.state[this.items[key]];
		newItems[index][itemKey] = value;
		this.setState(state => ({ ...state, [this.items[key]]: newItems }));
	};

	renderResponse = response => {
		if (Object.keys(response).length === 0) return null;
		let key = "error";
		if (response.hasOwnProperty("success")) key = "success";
		if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
		let cardClass = "card user-profile-card response-" + key;
		return (
			<div className={cardClass}>
				<div class="card-body">{response[key]}</div>
			</div>
		);
	};

	render() {
		let state = this.state;
		let main = (
			<>
				<div class="card user-profile-card">
					<div class="card-body">
						<form>
							<div class="form-group">
								<label for="exampleInputEmail1">
									M3 Id: {localStorage.getItem("trendId")}
								</label>
							</div>
						<div class="form-group">
							<label>{translator("Admin User Profile", "name_label")}</label>
							<input
								type="text"
								class="form-control settings-form"
								placeholder={translator("Project Setup", "enter_name_placeholder")}
								value={state.name}
								onChange={event => this.setState({ name: event.target.value })}
							/>
						</div>
							<div class="form-group">
								<label>{translator("Admin User Profile", "address_label")}</label>
								<input
									type="text"
									class="form-control settings-form"
									placeholder={translator("Project Setup", "enter_address_placeholder")}
									value={state.address_1}
									onChange={event =>
										this.setState({ address_1: event.target.value })
									}
								/>
							</div>
							<div class="form-group">
								<label>{translator("Admin User Profile", "city_label")}</label>
								<input
									type="text"
									class="form-control settings-form"
									placeholder={translator("Project Setup", "enter_city_placeholder")}
									value={state.city}
									onChange={event => this.setState({ city: event.target.value })}
								/>
							</div>
							<div class="form-group">
								<label>{translator("Admin User Profile", "province_label")}</label>
								<select
									class="dropdown-toggle form-control settings-form"
									type="button"
									id="dropdownMenuButton"
									value={state.province}
									onChange={event =>
										this.setState({ province: event.target.value })
									}
								>
									<option>{translator("Admin User Profile", "select_region_label")} &#8964;</option>
									<option value="AB">{translator("Misc", "province_ab")}</option>
									<option value="BC">{translator("Misc", "province_bc")}</option>
									<option value="MB">{translator("Misc", "province_mb")}</option>
									<option value="NB">{translator("Misc", "province_nb")}</option>
									<option value="NL">{translator("Misc", "province_nl")}</option>
									<option value="NT">{translator("Misc", "province_nt")}</option>
									<option value="NS">{translator("Misc", "province_ns")}</option>
									<option value="NU">{translator("Misc", "province_nu")}</option>
									<option value="ON">{translator("Misc", "province_on")}</option>
									<option value="PE">{translator("Misc", "province_pe")}</option>
									<option value="QC">{translator("Misc", "province_qc")}</option>
									<option value="SK">{translator("Misc", "province_sk")}</option>
									<option value="YT">{translator("Misc", "province_yt")}</option>
								</select>
							</div>
							<div class="form-group">
								<label>{translator("Admin User Profile", "postal_label")}</label>
								<input
									type="text"
									class="form-control settings-form postal-drop-down"
									placeholder={translator("Project Setup", "enter_postal_placeholder")}
									value={state.postal}
									onChange={event =>
										this.setState({ postal: event.target.value })
									}
								/>
							</div>
							<div class="form-group">
								<label>{translator("Admin User Profile", "phone_label")}</label>
								<input
									type="text"
									class="form-control settings-form"
									placeholder={translator("Project Setup", "enter_phone_placeholder")}
									value={state.phone}
									onChange={event => this.setState({ phone: event.target.value })}
								/>
							</div>
						<div class="form-group">
							<label>{translator("Admin User Profile", "website_label")}</label>
							<input
								type="text"
								class="form-control settings-form"
								placeholder={translator("Project Setup", "enter_website_placeholder")}
								value={state.website}
								onChange={event =>
									this.setState({ website: event.target.value })
								}
							/>
						</div>
							<div class="form-group">
								<label>{translator("Admin User Profile", "hours_label")}</label>
								<input
									type="text"
									class="form-control settings-form"
									placeholder={translator("Project Setup", "enter_hours_placeholder")}
									value={state.hours}
									onChange={event => this.setState({ hours: event.target.value })}
								/>
							</div>
							<div class="form-group">
								<button
									onClick={() => this.addItem("warehouse")}
									type="button"
									class="btn btn-outline-primary add-warehouse-btn"
								>
									{translator("Admin User Profile", "add_warehouse_btn")}
								</button>
							</div>
							<div class="form-group warehouse-form-group">
								<table class="table search-results-table">
									<thead id="search-projects-table-header">
										<tr>
											<th scope="col">{translator("Admin User Profile", "warehouse_number_header")}</th>
											<th scope="col">{translator("Admin User Profile", "primary_warehouse_header")}</th>
											<th scope="col" />
										</tr>
									</thead>
									<tbody>
										{state.listOfWarehouses.map((warehouse, index) =>
											warehouse.deleted ? null : (
												<tr key={index}>
													<td>
														<input
															type="text"
															class="form-control settings-form warehouse-setting-form"
															placeholder="#"
															defaultValue={warehouse.warehouse}
															onBlur={e =>
																this.editItem(
																	"warehouse",
																	index,
																	"warehouse",
																	e.target.value
																)
															}
														/>
													</td>
													<td>
														<input
															type="radio"
															class="form-control settings-form warehouse-setting-form setting-warehouse-check-input"
															name="primaryWarehouse"
															checked={
																index === state.primaryWarehouse
															}
															value={index}
															onClick={() =>
																this.setState({
																	primaryWarehouse: index
																})
															}
														/>
													</td>
													<td>
														<Button
															onClick={() =>
																this.editItem(
																	"warehouse",
																	index,
																	"deleted",
																	1
																)
															}
															color="primary"
														>
															<i
																class="fa fa-window-close fa-2x"
																aria-hidden="true"
															/>
														</Button>
													</td>
												</tr>
											)
										)}
									</tbody>
								</table>
							</div>
							<div class="form-group">
								<button
									onClick={() => this.addItem("email")}
									type="button"
									class="btn btn-outline-primary add-email-btn"
								>
									{translator("Admin User Profile", "add_email_btn")}
								</button>
							</div>
							<div class="form-group warehouse-form-group">
								<table class="table search-results-table">
									<thead id="search-projects-table-header">
										<tr>
											<th scope="col">{translator("Admin User Profile", "email_address_header")}</th>
											<th scope="col">{translator("Admin User Profile", "primary_email_header")}</th>
											<th scope="col" />
										</tr>
									</thead>
									<tbody>
										{state.listOfEmails.map((email, index) =>
											email.deleted ? null : (
												<tr key={index}>
													<td>
														<input
															type="text"
															class="form-control settings-form email-setting-form"
															placeholder="example@domain.ca"
															defaultValue={email.email}
															onBlur={e =>
																this.editItem(
																	"email",
																	index,
																	"email",
																	e.target.value
																)
															}
														/>
													</td>
													<td>
														<input
															type="radio"
															class="form-control settings-form warehouse-setting-form setting-warehouse-check-input"
															name="primaryEmail"
															checked={index === state.primaryEmail}
															value={index}
															onClick={() =>
																this.setState({
																	primaryEmail: index
																})
															}
														/>
													</td>
													<td>
														<Button
															onClick={() =>
																this.editItem(
																	"email",
																	index,
																	"deleted",
																	1
																)
															}
															color="primary"
														>
															<i
																class="fa fa-window-close fa-2x"
																aria-hidden="true"
															/>
														</Button>
													</td>
												</tr>
											)
										)}
					</tbody>
				</table>
			</div>
			<button
				onClick={this.updateConsultant}
				type="button"
				class="btn btn-primary"
			>
				{translator("Admin User Profile", "submit_btn")}
			</button>
		</form>
	</div>
</div>
{this.renderResponse(state.response)}
</>
);
return <SettingsWrapper header={translator("Admin User Profile", "page_title")} main={main} />;
}
}const mapStateToProps = state => {
	return {
		user: state.user,
		initialLogin: state.initialLogin,
		admin: state.admin,
		trendId: state.trendId,
		consultantWarehousesDeletingList: state.consultantWarehousesDeletingList,
		consultantEmailsDeletingList: state.consultantEmailsDeletingList,
		trendUserToken: state.userToken,
		listOfWarehousesToAddToConsultant: state.addTheseToConsultantWarehouses,
		listOfEmailsToAddToConsultant: state.addTheseToConsultantEmails,
		APIUrl: state.APIUrl,
		selected_language: state.selected_language
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
